/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LocationRequest { 
    displayName?: string;
    receiptName?: string;
    lat?: number;
    lng?: number;
    address1: string;
    address2?: string;
    city: string;
    postalCode: string;
    county?: string;
    country: string;
    hq?: boolean;
    office?: boolean;
    active?: boolean;
    loyaltyProgramId?: number;
}

